import {
  Picto,
  PictoEnum,
} from '@delmonicos/shared-design-system-react/src/components/picto/picto';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { ChargePointStatus } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/enums/charge-point-status.enum';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  ConnectorStatusMap,
  GenericConnectorStatusEnum,
} from '@app/feature/charge-point/helper/connector-status.helper';

import * as css from './legend-item.module.scss';

interface LegendItemComponentProps {
  status: ChargePointStatus;
  value: number;
}

export const LegendItemComponent = ({
  status,
  value,
}: LegendItemComponentProps): React.JSX.Element => {
  const { t } = useTranslation();

  const connectorStatus = ConnectorStatusMap[status] ?? 'unknown';
  const genericConnectorStatus = GenericConnectorStatusEnum[
    connectorStatus
  ] ?? {
    name: 'unavailable',
    color: 'bg-surface-secondary',
    picto: PictoEnum.Unavailable,
  };

  return (
    <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
      <Stack gap={GapEnum.S} alignItems="center">
        <div className={classNames(css[status], css.badge)} />
        <Picto name={genericConnectorStatus.picto} />
        <Text>
          {t(
            `delmonicos-shared-sdk.ocpp-enums-charge-point-status.${status ?? 'Unknown'}`,
          )}
        </Text>
      </Stack>
      <Text bold>{value}</Text>
    </Stack>
  );
};
